import { type ApolloError, useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import type { ARVisaApplications } from './types';
import type { DepartmentType } from '../../Application/graphql';
import type { SelectOption } from '../../../components';

const GET_AR_VISA_APPLICATIONS_AND_METADATA = gql`
  query (
    $filter: OfferedApplicationFilter!
    $sort: OfferDetailSorter
    $paginator: PaginatorOptions
  ) {
    visaApplicationList(filter: $filter, sort: $sort, paginator: $paginator) {
      data {
        applicationId
        applicationNo
        applicantName
        applicantEmail
        applicantNationality
        programmeType
        programmeCode
        status
        isFirmOffer
        entryYear
        referenceNo
      }
      paginator {
        count
      }
    }
    programmeChoiceMetadata {
      departments {
        value
        label
      }
      entryYears
      countryList {
        value
        label
      }
    }
  }
`;

export type DepartmentsAndEntryYear = {
  departments: DepartmentType[];
  entryYears: string[];
};

type GetARVisaApplicationList = {
  arVisaApplications: ARVisaApplications;
  departmentsAndEntryYear: DepartmentsAndEntryYear;
  countryList: SelectOption[];
  loading: boolean;
  error: ApolloError | undefined;
  refetch: () => void;
};

export const useGetARVisaApplicationList = (
  filter: any,
): GetARVisaApplicationList => {
  const { data, loading, error, refetch } = useQuery(
    GET_AR_VISA_APPLICATIONS_AND_METADATA,
    {
      variables: { filter },
      fetchPolicy: 'network-only',
    },
  );
  const arVisaApplications: ARVisaApplications = {
    data: data?.visaApplicationList?.data ?? [],
  };
  const departmentsAndEntryYear: DepartmentsAndEntryYear = {
    departments: data?.programmeChoiceMetadata?.departments ?? [],
    entryYears: data?.programmeChoiceMetadata?.entryYears ?? [],
  };

  const countryList: SelectOption[] =
    data?.programmeChoiceMetadata?.countryList ?? [];

  return {
    arVisaApplications,
    departmentsAndEntryYear,
    countryList,
    loading,
    error,
    refetch,
  };
};
